<template>
  <div>
    <AppHeader :shouldAlwaysFix="true" />
    <main>
      <slot></slot>
    </main>
    <AppFooter />
    <Toolbar />
  </div>
</template>

<script>
import AppHeader from "@/components/AppHeader/HeaderBar.vue";
import AppFooter from "@/components/AppFooter/Footer.vue";
import Toolbar from "@/components/Toolbar/Toolbar.vue";

export default {
  name: "DefaultLayout_HeaderFix",
  components: {
    AppHeader,
    AppFooter,
    Toolbar,
  },
};
</script>

<style scoped>
/* 计算 main 区域的高度，减去 header 和 footer 的高度 */
main {
  min-height: calc(100vh - var(--header-height) - var(--footer-height));
}
</style>